<template lang="pug">
  .quote-full-view(:class="quote.state" @click="clickHandler") 
    .modal
      header#modal-header
        h2 MITY<span>QUOTES</span>
        .icon-delete(@click="closeViewer")
          svg(xmlns="http://www.w3.org/2000/svg" width="18.423" height="18.532" viewBox="0 0 18.423 18.532")
            g(transform="translate(1.414 1.414)")
              path(d="M3624.407,339.461l7.8,7.8,7.8-7.8" transform="translate(-3624.407 -339.461)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
              path(d="M3624.407,347.259l7.8-7.8,7.8,7.8" transform="translate(-3624.407 -331.555)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
      .viewer
        .info-header
          h2 
            span.bold {{quote.id}}
            span.expiration(v-if="quote.expiration")  (Valid until {{formatStamp(quote.expiration)}})
          a.download(v-if="downloadLink" :href="downloadLink" target="_blank") Download as PDF
            svg(xmlns="http://www.w3.org/2000/svg" width="17.86" height="17.959" viewBox="0 0 17.86 17.959")
              g(transform="translate(-307.12 -193.25)")
                path(d="M987.052,1356.906l5.155,5.155,5.155-5.155" transform="translate(-676.114 -1155.856)" fill="none" stroke-linecap="round" stroke-width="1.5")
                path(d="M995.758,1345v12.021" transform="translate(-679.665 -1151)" fill="none" stroke-linecap="round" stroke-width="1.5")
          span.download(v-else)
            svg(aria-hidden="true" width="16" height="16" viewBox="0 0 512 512" focusable="false" class="fa-spin")
              path(d="M370.7 133.3c-31.3-29.3-71.8-45.3-114.9-45.3-77.5 0.1-144.3 53.2-162.8 126.8-1.3 5.4-6.1 9.2-11.7 9.2h-57.3c-7.5 0-13.2-6.8-11.8-14.2 21.6-114.9 122.5-201.8 243.7-201.8 66.4 0 126.8 26.1 171.3 68.7l35.7-35.7c15.1-15.1 41-4.4 41 17v134.1c0 13.3-10.7 24-24 24h-134.1c-21.4 0-32.1-25.9-17-41zM32 296h134.1c21.4 0 32.1 25.9 17 41l-41.8 41.8c31.3 29.3 71.8 45.3 114.9 45.3 77.4-0.1 144.3-53.1 162.8-126.8 1.3-5.4 6.1-9.2 11.7-9.2h57.3c7.5 0 13.2 6.8 11.8 14.2-21.6 114.9-122.5 201.8-243.7 201.8-66.4 0-126.8-26.1-171.3-68.7l-35.7 35.7c-15.1 15.1-41 4.4-41-17v-134.1c0-13.3 10.7-24 24-24z")
            | Preparing PDF Copy
          .info
            .shipping
              h5.bold Delivery Address:
              p {{customer.business}}
              p {{customer.street}}
              p {{customer.city}}, {{ customer.state}} {{ customer.postalCode }}
              br
              p(v-if="quote.hasDock") Yes, I have a loading dock
              p(v-else) No loading dock available
            .contact
              h5.bold Contact:
              p Attn: {{customer.name}}
              p Phone: {{customer.phoneNumber}}
        
            .rep(v-if="repName") 
              h5.bold Sales Rep: 
              a.messageRep(:href="'mailto:' + repEmail") {{repName}}
        .pricing-table
          .title
            .image
              p Item
            .description
              p Description
            .quantity
              p QTY
            .price
              p Unit Price
            .line-price
              p Line Total
          hr
          .product(v-for='item in quote.items' :class="quote.state == 'quoted' ? 'quoted' : ''")
            .image
              a.thumb-wrapper(:href="item.product.fullLink")
                img(:src="item.product.image")
            .description
              a(:href="item.product.link" target="_blank")
                h5.product-title {{ item.product.title }}
              p.product-variations {{ item.notes }}
            .quantity
              p {{item.quantity}}
            .price
              p {{ formatPrice(item.product.unitPrice) }}
            .line-price
              p {{ formatPrice(getLinePrice(item)) }}
          hr
          .totals
            p.total(v-if="quote.surchargePrice") Surcharge/Tariff Fee (2%):
            span.right(v-if="quote.surchargePrice") {{formatPrice(quote.surchargePrice)}}
            p.total Shipping Cost:
            span.right {{formatPrice(quote.freight)}}
            p.total(v-if="quote.liftGateCharge") Liftgate Charge:
            span.right(v-if="quote.liftGateCharge") {{formatPrice(quote.liftGateCharge)}}
            p.total Tax ({{quote.taxRate}}%):
            span.right {{formatPrice(quote.tax)}}
          hr
          .grand-total
            .notes
              p.bold Notes for Sales Rep: 
              textarea(disabled placeholder="Please let your sales rep if you have any  additional notes or questions about your quote request") {{quote.notes}}
            .total
              h4.bold TOTAL:
              span.bold.right {{formatPrice(quote.total)}}     
      footer#modal-footer(v-if="quote.state === 'quoted'")
        h4.bold Sign For Order             
        label(for="disclaimer")
          input#disclaimer(type="checkbox" v-model="checkDisclaimer")
          | I agree to the #[a(@click="showDisclaimer = !showDisclaimer") terms & conditions]
        p.disclaimer(v-if="showDisclaimer") *Applying your digital signature and tapping Accept Quote will begin your order process. Lead time is measured from receipt of prepayment. If you want to modify the order after it has been placed you must contact your sales or customer service representative.
        
        .accept-quote
          fieldset.seamless.with-icon
            label(for) Your Name 
            input(type="text" v-model="verifyName" :placeholder="'type your full name ('+customer.name+')'")

          button(@click="acceptQuote(quote)" :disabled="!verifyPlaceOrder || !checkDisclaimer") Accept Quote

        p.prepayment *A prepayment is required with most orders, check with your sales representative for details.
      footer#modal-footer.accepted(v-if="quote.state === 'accepted'")
        span Accepted by {{ customer.name }} <em v-if="quote.acceptedDate">on {{ formatStamp(quote.acceptedDate) }}</em>
</template>

<script>
import connect from "../scripts/database.js";
import { Quotes } from "../scripts/quotes.js";
import Accounts from "../scripts/accounts.js";
import Axios from "axios";

export default {
  props: ["quote"],
  data() {
    return {
      repName: null,
      repEmail: null,
      downloadLink: null,
      customer: "",
      verifyName: "",
      showDisclaimer: false,
      checkDisclaimer: false,
      retry: 0
    };
  },
  computed: {
    verifyPlaceOrder: function() {
      if (this.customer.name == this.verifyName) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    closeViewer() {
      this.$root.fullView = false;
    },
    formatStamp(value, type) {
      if (typeof value == "object") {
        return this.formatDate(value.seconds);
      } else {
        return this.formatDate(value);
      }
    },
    getLinePrice(item) {
      var amt = parseFloat(item.product.unitPrice) * parseInt(item.quantity);
      return isNaN(amt) ? 0 : parseFloat(amt.toFixed(2));
    },
    formatPrice(value) {
      if (value) {
        return (
          "$" +
          parseFloat(value)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
        );
      } else {
        return "0.00";
      }
    },
    getRep(quote) {
      connect.db
        .collection("support")
        .doc(quote.assignedTo)
        .get()
        .then(doc => {
          var salesRep = doc.data();
          this.repName = salesRep.name;
          this.repEmail = salesRep.email;
        });
    },
    acceptQuote(quote) {
      this.quote.acceptedDate = Date.now();
      this.quote.state = "accepted";
      this.quote.version += 1;
      Quotes.saveQuote(this.quote);
      this.$root.fullView = false;
      this.$root.confirmation.msg = "Quote Accepted!";
      this.$root.confirmation.returnState = "quotes";
      this.$root.confirmation.returnMsg = "Manage requests";
      this.$root.confirmation.open = true;
    },
    checkDownloadLink() {
      let fileName =
        this.$root.currentUser.uid +
        "/" +
        this.quote.id +
        "-v" +
        this.quote.version +
        ".pdf";

      connect.storage
        .ref("invoices")
        .child(fileName)
        .getDownloadURL()
        .then(url => {
          this.downloadLink = url;
        })
        .catch(error => {
          return Axios.post(
            `${process.env.VUE_APP_FIREBASE.cloudFunctionURL}/requestPDF`,
            {
              quoteId: this.quote.id,
              userId: this.$root.currentUser.uid
            }
          )
            .then(() => {
              //retry
              if (this.retry <= 3) {
                this.checkDownloadLink();
                this.retry++;
              }
            })
            .catch(() => {
              console.log("invoice file not found");
            });
        });
    },
    clickHandler(event) {
      if (event.target.classList.contains("quote-full-view")) {
        this.closeViewer();
      }
    }
  },
  created() {
    Accounts.getAccount(this.$root.currentUser.uid).then(results => {
      this.customer = results;
    });
  },
  mounted: function() {
    this.getRep(this.quote);
    this.checkDownloadLink();
  }
};
</script>

<style lang="scss">
@import "../assets/styles/reset.scss";
@import "../assets/styles/variables.scss";

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

#app .quote-full-view {
  z-index: 109000;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 110000;
  line-height: normal;
  .bold {
    font-weight: 500;
  }
  hr {
    margin: 1em 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: solid 2px $border_gray;
    width: 100%;
    max-width: none;
  }
  .modal {
    max-height: 96vh;
    max-width: 1200px;
    width: 90%;
    margin: auto;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    min-width: 200px;
    min-height: 150px;
    overflow-y: auto;
    background-color: white;
    border-radius: 0;
    padding: 0;
    box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.6);
    header#modal-header {
      box-sizing: border-box;
      background-color: $header_color;
      padding: 2em;
      color: white;
      position: relative;
      .icon-delete {
        position: absolute;
        top: 1em;
        right: 1em;
        svg {
          width: 20px;
          height: 20px;
        }
      }
      .icon-delete:hover {
        cursor: pointer;
        svg path {
          stroke: #ccc;
        }
      }
    }
    .viewer {
      position: relative;
      .info-header {
        font-size: 0.9em;
        padding: 18px 36px;
        background-color: $light_gray;
        h2 {
          color: $text_color;
          margin-bottom: 1em;
          text-transform: none;
          span {
            font-size: 20px;
          }
          span.expiration {
            font-size: 14px;
          }
        }
        h5 {
          font-weight: 500;
          margin-bottom: 1em;
          color: $text_color;
        }
        .download {
          position: absolute;
          right: 2em;
          top: 2em;
          svg {
            fill: $link_color;
            vertical-align: middle;
            margin-left: 0.3em;
            path {
              stroke: $link_color;
            }
          }
        }
        .download:hover {
          cursor: pointer;
          svg {
            fill: $link_hover;
            path {
              stroke: $link_hover;
            }
          }
        }
        span.download {
          svg {
            animation-name: spin;
            animation-duration: 1.5s;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            transform-origin: 50% 50%;
            display: inline-block;
          }
        }
        .info {
          display: flex;
          .shipping,
          .contact,
          .sales-rep {
            margin-right: 3em;
          }
        }
      }

      .pricing-table {
        margin: 1em 2em;
        padding: 0 2em;
        .product {
          margin-bottom: 1em;
        }
        .title {
          color: $text_color;
          font-weight: 500;
        }
        .product,
        .title {
          display: flex;
          flex-wrap: wrap;
          margin-right: 1em;
          .image {
            width: 10%;
            a {
              text-align: center;
            }
            img {
              width: 100%;
              max-width: 75px;
              margin: auto;
              border-radius: 10px;
            }
          }
          .description {
            width: 30%;
            padding-left: 0.5em;
            .product-title {
              color: $link_color;
              font-weight: 500;
              margin-bottom: 5px;
            }
            .product-title:hover {
              color: $link_hover;
            }
          }
          .quantity {
            width: 20%;
            text-align: right;
          }
          .price {
            width: 20%;
            text-align: right;
          }
          .line-price {
            width: 20%;
            text-align: right;
          }
          .quantity,
          .price,
          .line-price {
            color: $text_color;
          }
        }
      }
      .totals {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        p:last-of-type {
          margin-bottom: 0;
        }
        .total {
          width: 66%;
          margin-bottom: 1em;
        }
        span {
          width: 34%;
          padding-right: 1em;
          text-align: right;
        }
      }
      .grand-total {
        display: flex;
        flex-wrap: wrap;
        color: $text_color;
        width: 100%;
        .notes {
          width: 60%;
          textarea {
            width: 85%;
            padding: 0.5em;
            border-radius: 8px;
            resize: none;
            margin-top: 0.5em;
            height: 65px;
            background-color: transparent;
          }
        }
        .total {
          width: 40%;
          h4 {
            display: inline-block;
          }
          span {
            float: right;
            margin-right: 1em;
          }
        }
      }
    }
    footer#modal-footer {
      background-color: $light_gray;
      margin: 0;
      padding: 2em;
      color: #000;
      max-width: inherit;
      width: auto;
      height: auto;
      h4 {
        border-bottom: 1px #ccc solid;
        font-weight: bold;
        margin-bottom: 0.8em;
        padding-bottom: 0.3em;
        text-transform: initial;
      }

      label {
        cursor: pointer;

        input[type="checkbox"] {
          height: 15px;
          margin-right: 0.5em;
          width: 15px;
          vertical-align: text-top;
        }
      }

      .accept-quote {
        display: flex;
        flex-direction: row;
        margin: 0.8em 0;
        width: 50%;

        fieldset.seamless:not(.checkbox) {
          width: 60%;
          position: relative;
          label[for] {
            top: 5px;
            left: 0;
            position: absolute;
            font-size: 12px;
            top: 3px;
            left: 6px;
            color: #878787;
            padding: 0.1em 0.4em;
            margin: 0;
          }

          input[type="text"] {
            border: 1px #ccc solid;
            border-right: none;
            box-sizing: border-box;
            margin: 0;
            padding: 1.5em 0.5em 0.5em 0.7em !important;
            width: 100%;
            border-radius: 0;
          }
        }
        button {
          color: #fff;
          background-color: $button_color;
          border: none;

          &:hover:not(.disabled) {
            background-color: $button_hover;
          }
        }

        button:disabled {
          background-color: $border_gray;
        }
        button:disabled:hover {
          cursor: default;
        }
      }

      #request-freight {
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 1em;
      }

      button {
        flex-grow: 1;
      }

      p.prepayment {
        font-size: 12px;
        font-style: italic;
        margin: 1em 0 0;
        text-align: left;
      }

      p {
        margin: 1em 0;
        text-align: center;

        &.disclaimer {
          font-size: 12px;
          font-style: italic;
          text-align: center;
        }

        a {
          color: $primary_color;
          cursor: pointer;

          &:hover {
            color: $secondary_color;
          }
        }
      }
      &.accepted {
        margin: 0;
        padding: 2em;
        width: 100%;
        text-align: center;
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  #app .quote-full-view {
    .modal {
      .viewer {
        .pricing-table {
          padding: 0;
        }
      }
    }
  }
}
</style>
